import * as yup from "yup";
const parseAmount = (value) => parseFloat(value || "0") || 0;

const journalEntrySchema = yup.object().shape({
  reference_number: yup.string().nullable(),
  reference_date: yup.string().nullable(),
  narration: yup.string().nullable(),
  number_series: yup.string().required("Number Series is required"),
  entry_number: yup.string().required("Entry Number is required"),
  voucher_date: yup.string().required("Date is required"),
  journal_account: yup
    .array()
    .of(
      yup.object().shape({
        account: yup.string().required("Account is required"),
        credit: yup
          .string()
          .nullable()
          .transform((value) => (value === "" || value == null ? "0" : value))
          .test(
            "credit-or-debit",
            "Either credit or debit is required",
            function (value) {
              const { debit } = this.parent;
              return !!value || !!debit;
            }
          ),
        debit: yup
          .string()
          .nullable()
          .transform((value) => (value === "" || value == null ? "0" : value))
          .test(
            "debit-or-credit",
            "Either debit or credit is required",
            function (value) {
              const { credit } = this.parent;
              return !!value || !!credit;
            }
          ),
      })
    )
    .test(
      "balanced-entries",
      "Total debit and credit must be equal",
      function (entries) {
        if (!entries || !entries.length) return true;

        const parseAmountInCents = (val: string) =>
          Math.round(parseAmount(val) * 100);

        const totalDebit = entries.reduce(
          (sum, entry) => sum + parseAmountInCents(entry.debit),
          0
        );
        const totalCredit = entries.reduce(
          (sum, entry) => sum + parseAmountInCents(entry.credit),
          0
        );
        return totalDebit === totalCredit;
      }
    ),
});
export default journalEntrySchema;
